import React, {useEffect, useMemo, useRef} from "react";
import {CoreOptions, RowSelectionState} from "@tanstack/react-table";

import {transformIdsToRowSelectionState} from "../utils/transform_ids_to_row_selection_state";
import {useTableRowSelectionState} from "./use_table_row_selection_state";

interface IParams<TDataSource> {
    data: TDataSource[];
    filters: Record<string, unknown>;
    initialSelectedRowIds?: string[];
    rowSelection?: RowSelectionState;
    onRowSelectionChange?: React.Dispatch<React.SetStateAction<RowSelectionState>>;
    areAllRecordsSelected?: boolean;
    getRowId: CoreOptions<TDataSource>["getRowId"];
}

export const useRowSelection = <TDataSource extends object>(props: IParams<TDataSource>) => {
    const {getRowId} = props;

    const rowSelectionInitialState = useMemo(() => {
        if (props.areAllRecordsSelected && getRowId) {
            return transformIdsToRowSelectionState(props.data.map((record, index) => getRowId(record, index)));
        }

        return transformIdsToRowSelectionState(props.initialSelectedRowIds);
    }, []);

    useEffect(() => {
        if (props.areAllRecordsSelected && getRowId) {
            (props.onRowSelectionChange ?? onRowSelectionChange)(
                transformIdsToRowSelectionState(props.data.map((record, index) => getRowId(record, index))) || {}
            );
        }
    }, [props.areAllRecordsSelected, props.data]);

    const previousFilters = useRef<string | null>(null);

    if (previousFilters.current === null) {
        // set initial filters value
        previousFilters.current = JSON.stringify(props.filters);
    }

    useEffect(() => {
        const filtersString = JSON.stringify(props.filters);

        // only if filters' values are different
        if (previousFilters.current !== filtersString) {
            previousFilters.current = filtersString;
            (props.onRowSelectionChange ?? onRowSelectionChange)({});
        }
    }, [props.filters]);

    const {rowSelection, onRowSelectionChange} = useTableRowSelectionState(rowSelectionInitialState);

    return {
        rowSelection: props.onRowSelectionChange && props.rowSelection ? props.rowSelection : rowSelection,
        onRowSelectionChange: props.onRowSelectionChange && props.rowSelection ? props.onRowSelectionChange : onRowSelectionChange
    };
};
import React, {useEffect, useMemo, useRef} from "react";
import {CoreOptions, RowSelectionState} from "@tanstack/react-table";

import {transformIdsToRowSelectionState} from "../utils/transform_ids_to_row_selection_state";
import {useTableRowSelectionState} from "./use_table_row_selection_state";

interface IParams<TDataSource> {
    data: TDataSource[];
    filters: Record<string, unknown>;
    initialSelectedRowIds?: string[];
    rowSelection?: RowSelectionState;
    onRowSelectionChange?: React.Dispatch<React.SetStateAction<RowSelectionState>>;
    areAllRecordsSelected?: boolean;
    getRowId: CoreOptions<TDataSource>["getRowId"];
}

export const useRowSelection = <TDataSource extends object>(props: IParams<TDataSource>) => {
    const {getRowId} = props;

    const rowSelectionInitialState = useMemo(() => {
        if (props.areAllRecordsSelected && getRowId) {
            return transformIdsToRowSelectionState(props.data.map((record, index) => getRowId(record, index)));
        }

        return transformIdsToRowSelectionState(props.initialSelectedRowIds);
    }, []);

    useEffect(() => {
        if (props.areAllRecordsSelected && getRowId) {
            (props.onRowSelectionChange ?? onRowSelectionChange)(
                transformIdsToRowSelectionState(props.data.map((record, index) => getRowId(record, index))) || {}
            );
        }
    }, [props.areAllRecordsSelected, props.data]);

    const previousFilters = useRef<string | null>(null);

    if (previousFilters.current === null) {
        // set initial filters value
        previousFilters.current = JSON.stringify(props.filters);
    }

    useEffect(() => {
        const filtersString = JSON.stringify(props.filters);

        // only if filters' values are different
        if (previousFilters.current !== filtersString) {
            previousFilters.current = filtersString;
            (props.onRowSelectionChange ?? onRowSelectionChange)({});
        }
    }, [props.filters]);

    const {rowSelection, onRowSelectionChange} = useTableRowSelectionState(rowSelectionInitialState);

    return {
        rowSelection: props.onRowSelectionChange && props.rowSelection ? props.rowSelection : rowSelection,
        onRowSelectionChange: props.onRowSelectionChange && props.rowSelection ? props.onRowSelectionChange : onRowSelectionChange
    };
};
